import { useState } from "react";
import ProductNote from "./ProductNote";
import { BsPencilFill } from "react-icons/bs";
import { FaMinus, FaPlus, FaTrashAlt } from "react-icons/fa";
import { useAppContext } from "../../context/appContext";

const SingleProduct = (props) => {
    const { updateQuantity, deleteItem, toggleModal } = useAppContext();

    const [active, setActive] = useState(false);

    const setActiveHandler = () => {
        setActive(!active);
    };

    const toggleModalHandler = (event) => {
        toggleModal(props.id, "edit");
    };

    const decreaseHandler = (event) => {
        event.stopPropagation();
        updateQuantity({ id: props.id, quantity: props.quantity }, "decrease");
    };

    const increaseHandler = (event) => {
        // console.log("increase", props.id);
        event.stopPropagation();
        updateQuantity({ id: props.id }, "increase");
    };

    const deleteHandler = (event) => {
        event.stopPropagation();
        deleteItem(props.id);
    };

    if (active) {
        return (
            <div
                className='my-2 flex flex-1 cursor-pointer flex-col justify-around bg-main-600 py-2 font-mono text-white'
                onClick={setActiveHandler}
            >
                <div className='flex flex-1 justify-around'>
                    <p className='weight-medium flex w-full max-w-[230px] flex-[2_1_auto] pl-2 '>
                        {props.name.length > 20 ? props.name.substr(0, 20) + "..." : props.name}
                    </p>
                    <p className='flex w-[15px] flex-[1_1_auto] items-end justify-end pr-4'>
                        {props.quantity}
                    </p>
                    <p className='flex w-[55px] flex-[1_1_auto] items-center  px-1 text-center'>
                        {props.price.toFixed(2)} £
                    </p>
                    <p className='flex w-[55px] flex-[1_1_auto]  items-end  justify-end pr-2 font-medium'>
                        {(parseFloat(props.quantity) * parseFloat(props.price)).toFixed(2)} £
                    </p>
                </div>
                <div>
                    <ProductNote content={props.instruction} />
                </div>
                <div className='mt-6 mb-3 flex flex-col'>
                    <div className='flex flex-1 flex-row justify-around text-[10px]'>
                        <div className='flex flex-col content-center items-center uppercase'>
                            <BsPencilFill className='text-2xl' onClick={toggleModalHandler} />
                            <p className='mt-2'>Add note</p>
                        </div>
                        <div className='flex flex-col content-center items-center uppercase'>
                            <div className='flex'>
                                <FaMinus className='mr-4 text-2xl' onClick={decreaseHandler} />
                                <p className='text-base'>{props.quantity}</p>
                                <FaPlus className='ml-4 text-2xl' onClick={increaseHandler} />
                            </div>
                            <p className='mt-2'>Quantity</p>
                        </div>
                        <div className='flex flex-col  content-center items-center uppercase'>
                            <FaTrashAlt className='text-2xl' onClick={deleteHandler} />
                            <p className='mt-2'>Delete</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div
                className='my-2 flex flex-1 cursor-pointer flex-col justify-around py-2 font-mono text-gray-900'
                onClick={setActiveHandler}
            >
                <div className='flex flex-1 justify-around'>
                    <p className='weight-medium flex w-full max-w-[230px] flex-[2_1_auto] pl-2 '>
                        {props.name.length > 20 ? props.name.substr(0, 20) + "..." : props.name}
                    </p>
                    <p className='flex w-[10px] flex-[1_1_auto] items-end justify-end pr-4'>
                        {props.quantity}
                    </p>
                    <p className='flex w-[55px] flex-[1_1_auto] items-center  px-1 text-center'>
                        {props.price.toFixed(2)} £
                    </p>
                    <p className='flex w-[60px] flex-[1_1_auto]  items-end justify-end pr-2 font-medium'>
                        {(parseFloat(props.quantity) * parseFloat(props.price)).toFixed(2)}
                    </p>
                </div>
            </div>
        );
    }
};

export default SingleProduct;
